/**
 * Trim special characters only from start and end of string
 * Keeps the inner content intact (like emails)
 * @param {string} str
 * @returns {string}
 */
export function sanitizeString(str) {
  if (!str) return str;
  return str.replace(/^[^\w]+|[^\w]+$/g, '').trim();
}

/**
 * Sanitize status array for Zoho API
 * Trims special chars from start/end and replaces spaces with underscores
 */
export function sanitizeStatusArray(statusArray) {
  if (!Array.isArray(statusArray)) return [];
  return statusArray
    .map(status => sanitizeString(status))
    .filter(Boolean)
    .map(status => status.replace(/\s+/g, '_'));
}
